<script setup lang="ts">
import {
    IconCircleCheck,
    IconCircleX,
    IconExclamationCircle,
    IconInfoCircle,
} from "@tabler/icons-vue";

type ToastType = 'success' | 'error' | 'info' | 'warning'

defineProps({
    message: {
        type: String,
        required: true
    },
    type: {
        type: String as () => ToastType,
        default: 'info',
        validator: (value: string) => ['success', 'error', 'warning', 'info'].includes(value)
    }
})

const emit = defineEmits(['close'])

const close = () => {
    emit('close')
}
</script>

<style>
@keyframes toast-slide-in {
    from {
        transform: translateY(100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes toast-fade-out {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}

.animate-toast-slide-in {
    animation: toast-slide-in 1s ease;
}

.toast-fade-out {
    animation: toast-fade-out 1s forwards;
}
</style>
<template>
    <div class="toast-notification fixed inset-0 flex items-end justify-center p-4 pointer-events-none z-50">
        <div
            class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-zinc-900 shadow-2xl border border-zinc-200 dark:border-zinc-700">
            <div class="flex items-start justify-center p-4">
                <IconCircleCheck v-if="type == 'success'" class="size-5 text-green-400 stroke-2" aria-hidden="true" />
                <IconCircleX v-if="type == 'error'" class="size-5 text-red-400 stroke-2" aria-hidden="true" />
                <IconInfoCircle v-if="type == 'info'" class="size-5 text-blue-400 stroke-2" aria-hidden="true" />
                <IconExclamationCircle v-if="type == 'warning'" class="size-5 text-yellow-400 stroke-2"
                    aria-hidden="true" />
                <div class="ml-3 w-0 flex-1 pt-0.5">
                    <div class="text-sm font-medium text-white">
                        {{ message }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>